import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon, LockIcon, UserIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-867">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-868">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-869">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-870" />
          <span data-id="element-871">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-872">
        <div className="text-center mb-12" data-id="element-873">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-874">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-875">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-876">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-877">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-878">
              <h2 className="text-xl font-bold text-white" data-id="element-879">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-880">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-881">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-882">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-883">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-884">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-885">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-886">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-887">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-888">
                      <span data-id="element-889">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-890" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-891">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-892">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-893">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-894">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-895" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-896">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-897">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-898">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-899">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-900" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-901">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-902">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-903">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-904">
              <h2 className="text-xl font-bold text-white" data-id="element-905">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-906">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-907">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-908">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-909">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-910">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-911">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-912">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-913">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-914">
                      <span data-id="element-915">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-916" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-917">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-918">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-919">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-920">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-921" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-922">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-923">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-924">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-925">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-926" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-927">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-928">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-929">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-930">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-931">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-932">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-933">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-934">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-935">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-936">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-937">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-938">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-939">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-940">
                      <span data-id="element-941">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-942" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-943">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-944">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-945">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-946">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-947" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-948">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-949">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-950">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-951">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-952" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-953">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-954">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-955">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-956">
              <h2 className="text-xl font-bold text-white" data-id="element-957">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-958">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-959">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-960">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-961">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-962">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-963">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-964">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-965">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-966">
                      <span data-id="element-967">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-968" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-969">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-970">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-971">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-972">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-973" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-974">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-975">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-976">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-977">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-978" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-979">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-980">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-981">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-982">
              <h2 className="text-xl font-bold text-white" data-id="element-983">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-984">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-985">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-986">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-987">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-988">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-989">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-990">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-991">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-992">
                      <span data-id="element-993">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-994" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-995">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-996">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-997">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-998">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-999" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-1000">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-1001">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-1002">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-1003">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-1004" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-1005">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-1006">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1007">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-1008">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-1009">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1010">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-1011">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1012">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-1013">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-1014">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-1015">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-1016">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-1017">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-1018">
                      <span data-id="element-1019">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-1020" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-1021">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-1022">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-1023">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1024">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1025" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1026">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1027">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-1028">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-1029">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-1030" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-1031">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1032">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6 Expanded: Core Purple Lead */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1033">
            <div className="bg-white px-8 py-4 border-b-2 border-[#631bb7]" data-id="element-1034">
              <h2 className="text-xl font-bold text-[#1a0647]" data-id="element-1035">
                Option 6 Expanded: Light & Airy, Core Purple Lead
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1036">
                Deep dive • Showing how to use #631bb7 with restraint
              </p>
            </div>
            <div className="p-8 space-y-12" data-id="element-1037">
              {/* 1. Hero Preview */}
              <div data-id="element-1038">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1039">
                  1. Hero Surface
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm relative overflow-hidden" data-id="element-1040">
                  {/* Subtle background wash */}
                  <div className="absolute inset-0 bg-[#631bb7] opacity-[0.02] pointer-events-none" data-id="element-1041"></div>

                  <div className="relative z-10" data-id="element-1042">
                    <div className="inline-block bg-[#631bb7] bg-opacity-[0.06] text-[#631bb7] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#631bb7] border-opacity-20" data-id="element-1043">
                      🚀 New Feature
                    </div>
                    <h3 className="text-3xl md:text-4xl font-bold text-[#1a0647] mb-4 tracking-tight" data-id="element-1044">
                      Protect your family from digital chaos
                    </h3>
                    <p className="text-gray-600 mb-8 max-w-xl text-lg" data-id="element-1045">
                      Take control of your family's digital security with our
                      comprehensive protection tools. Simple, guided, and
                      effective.
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-1046">
                      <button className="bg-[#631bb7] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#501594] transition-all shadow-sm flex items-center space-x-2" data-id="element-1047">
                        <span data-id="element-1048">Get Started</span>
                        <ArrowRightIcon size={18} data-id="element-1049" />
                      </button>
                      <button className="bg-white border-2 border-gray-200 text-[#1a0647] px-7 py-3.5 rounded-lg font-semibold hover:border-[#631bb7] hover:text-[#631bb7] transition-all" data-id="element-1050">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. Button Spectrum */}
              <div data-id="element-1051">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1052">
                  2. Button Hierarchy
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 flex flex-wrap items-center gap-6" data-id="element-1053">
                  <button className="bg-[#631bb7] text-white px-6 py-2.5 rounded-md font-medium hover:bg-[#501594] transition-colors shadow-sm" data-id="element-1054">
                    Primary Action
                  </button>
                  <button className="bg-white border border-[#631bb7] text-[#631bb7] px-6 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1055">
                    Secondary Outline
                  </button>
                  <button className="text-[#631bb7] px-4 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1056">
                    Ghost Button
                  </button>
                  <div className="h-8 w-px bg-gray-200 mx-2" data-id="element-1057"></div>
                  <button className="bg-[#01ced1] text-[#1a0647] px-5 py-2 rounded-full text-sm font-bold hover:bg-[#00b8b8] transition-colors shadow-sm" data-id="element-1058">
                    Accent / Special
                  </button>
                </div>
              </div>

              {/* 3. Feature Cards */}
              <div data-id="element-1059">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1060">
                  3. Interactive Cards
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1061">
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1062">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1063">
                      <ShieldIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1064" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1065">
                      Bank-Level Security
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1066">
                      Enterprise-grade protection scaled for your family's
                      everyday needs.
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1067">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1068">
                      <LockIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1069" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1070">
                      Privacy First
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1071">
                      Your data stays yours. We never sell or share your
                      personal information.
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1072">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1073">
                      <UserIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1074" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1075">
                      Family Managed
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1076">
                      One dashboard to monitor and protect everyone you care
                      about.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4. Soft Surface */}
              <div data-id="element-1077">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1078">
                  4. Soft Section Fill
                </h3>
                <div className="bg-[#631bb7] bg-opacity-[0.04] rounded-2xl p-10 border border-[#631bb7] border-opacity-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1079">
                  <div data-id="element-1080">
                    <h4 className="text-2xl font-bold text-[#1a0647] mb-3" data-id="element-1081">
                      Ready to secure your family?
                    </h4>
                    <p className="text-gray-600 max-w-md" data-id="element-1082">
                      Join thousands of families who sleep better knowing their
                      digital lives are protected by Caveo.
                    </p>
                  </div>
                  <a href="#" className="inline-flex items-center gap-2 text-[#631bb7] font-semibold hover:text-[#501594] transition-colors whitespace-nowrap" data-id="element-1083">
                    View pricing plans <ChevronRightIcon size={18} data-id="element-1084" />
                  </a>
                </div>
              </div>

              {/* 5. Usage Legend */}
              <div data-id="element-1085">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1086">
                  5. Usage Rules (Restraint)
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1087">
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1088">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1089">
                      <CheckIcon size={18} className="text-green-600" data-id="element-1090" /> Where
                      to use Purple
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1091">
                      <li className="flex items-start gap-2" data-id="element-1092">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] shrink-0 mt-0.5" data-id="element-1093"></div>
                        <span data-id="element-1094">
                          <strong data-id="element-1095">Primary Actions:</strong> Main CTAs and
                          important buttons
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1096">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-20 border border-[#631bb7] shrink-0 mt-0.5" data-id="element-1097"></div>
                        <span data-id="element-1098">
                          <strong data-id="element-1099">Interactive States:</strong> Hover borders,
                          active tabs, selected items
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1100">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-10 shrink-0 mt-0.5" data-id="element-1101"></div>
                        <span data-id="element-1102">
                          <strong data-id="element-1103">Icon Fills & Badges:</strong> 5-10% opacity
                          washes for visual interest
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1104">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1105">
                      <div className="w-4 h-4 rounded-full border-2 border-red-500 flex items-center justify-center" data-id="element-1106">
                        <div className="w-2 h-0.5 bg-red-500 rotate-45" data-id="element-1107"></div>
                      </div>
                      Where NOT to use Purple
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1108">
                      <li className="flex items-start gap-2" data-id="element-1109">
                        <div className="w-4 h-4 rounded border border-gray-300 shrink-0 mt-0.5" data-id="element-1110"></div>
                        <span data-id="element-1111">
                          <strong data-id="element-1112">Structural Borders:</strong> Keep standard
                          borders gray-200
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1113">
                        <div className="w-4 h-4 rounded bg-[#1a0647] shrink-0 mt-0.5" data-id="element-1114"></div>
                        <span data-id="element-1115">
                          <strong data-id="element-1116">Typography:</strong> Use Dark Purple (#1a0647)
                          or Gray-600 for text
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1117">
                        <div className="w-4 h-4 rounded bg-white border border-gray-200 shrink-0 mt-0.5" data-id="element-1118"></div>
                        <span data-id="element-1119">
                          <strong data-id="element-1120">Heavy Backgrounds:</strong> Avoid large solid
                          purple panels; keep it airy
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6 Refined: Blue Lead, Purple Accent */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-1121">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-1122">
              <h2 className="text-xl font-bold text-[#1a0647]" data-id="element-1123">
                Option 6 Refined: Blue Lead, Purple Accent
              </h2>
              <p className="text-sm text-gray-600" data-id="element-1124">
                Light & Airy • Blue (#214ae9) for primary actions, purple
                (#631bb7) as the accent — no cyan
              </p>
            </div>
            <div className="p-8 space-y-12" data-id="element-1125">
              {/* 1. Hero Preview */}
              <div data-id="element-1126">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1127">
                  1. Hero Surface
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm relative overflow-hidden" data-id="element-1128">
                  {/* Subtle purple accent wash */}
                  <div className="absolute inset-0 bg-[#631bb7] opacity-[0.02] pointer-events-none" data-id="element-1129"></div>

                  <div className="relative z-10" data-id="element-1130">
                    {/* Purple accent badge */}
                    <div className="inline-block bg-[#631bb7] bg-opacity-[0.06] text-[#631bb7] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#631bb7] border-opacity-20" data-id="element-1131">
                      🚀 New Feature
                    </div>
                    <h3 className="text-3xl md:text-4xl font-bold text-[#1a0647] mb-4 tracking-tight" data-id="element-1132">
                      Protect your family from digital chaos
                    </h3>
                    <p className="text-gray-600 mb-8 max-w-xl text-lg" data-id="element-1133">
                      Take control of your family's digital security with our
                      comprehensive protection tools. Simple, guided, and
                      effective.
                    </p>
                    <div className="flex flex-wrap gap-4" data-id="element-1134">
                      {/* Blue primary action */}
                      <button className="bg-[#214ae9] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#1a3bb8] transition-all shadow-sm flex items-center space-x-2" data-id="element-1135">
                        <span data-id="element-1136">Get Started</span>
                        <ArrowRightIcon size={18} data-id="element-1137" />
                      </button>
                      {/* Purple-accented secondary */}
                      <button className="bg-white border-2 border-gray-200 text-[#1a0647] px-7 py-3.5 rounded-lg font-semibold hover:border-[#631bb7] hover:text-[#631bb7] transition-all" data-id="element-1138">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. Button Hierarchy */}
              <div data-id="element-1139">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1140">
                  2. Button Hierarchy
                </h3>
                <div className="bg-white rounded-xl p-8 border border-gray-200 flex flex-wrap items-center gap-6" data-id="element-1141">
                  {/* Blue = primary */}
                  <button className="bg-[#214ae9] text-white px-6 py-2.5 rounded-md font-medium hover:bg-[#1a3bb8] transition-colors shadow-sm" data-id="element-1142">
                    Primary Action
                  </button>
                  {/* Purple = accent / secondary */}
                  <button className="bg-white border border-[#631bb7] text-[#631bb7] px-6 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1143">
                    Secondary Outline
                  </button>
                  <button className="text-[#631bb7] px-4 py-2.5 rounded-md font-medium hover:bg-[#631bb7] hover:bg-opacity-5 transition-colors" data-id="element-1144">
                    Ghost Accent
                  </button>
                  <div className="h-8 w-px bg-gray-200 mx-2" data-id="element-1145"></div>
                  {/* Soft purple pill for tertiary emphasis (replaces cyan) */}
                  <button className="bg-[#631bb7] bg-opacity-[0.08] text-[#631bb7] px-5 py-2 rounded-full text-sm font-semibold hover:bg-opacity-[0.14] transition-colors" data-id="element-1146">
                    Accent Pill
                  </button>
                </div>
              </div>

              {/* 3. Feature Cards */}
              <div data-id="element-1147">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1148">
                  3. Interactive Cards
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1149">
                  {/* Blue-led card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#214ae9] hover:shadow-md transition-all cursor-pointer group" data-id="element-1150">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1151">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1152" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1153">
                      Bank-Level Security
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1154">
                      Enterprise-grade protection scaled for your family's
                      everyday needs.
                    </p>
                  </div>
                  {/* Purple-accent card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#631bb7] hover:shadow-md transition-all cursor-pointer group" data-id="element-1155">
                    <div className="w-12 h-12 bg-[#631bb7] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1156">
                      <LockIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1157" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1158">
                      Privacy First
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1159">
                      Your data stays yours. We never sell or share your
                      personal information.
                    </p>
                  </div>
                  {/* Blue-led card */}
                  <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#214ae9] hover:shadow-md transition-all cursor-pointer group" data-id="element-1160">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-[0.06] rounded-xl flex items-center justify-center mb-5 group-hover:bg-opacity-10 transition-all" data-id="element-1161">
                      <UserIcon className="w-6 h-6 text-[#214ae9]" data-id="element-1162" />
                    </div>
                    <h4 className="text-lg font-semibold text-[#1a0647] mb-2" data-id="element-1163">
                      Family Managed
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1164">
                      One dashboard to monitor and protect everyone you care
                      about.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4. Soft Surface (purple accent fill) */}
              <div data-id="element-1165">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1166">
                  4. Soft Section Fill
                </h3>
                <div className="bg-[#631bb7] bg-opacity-[0.04] rounded-2xl p-10 border border-[#631bb7] border-opacity-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1167">
                  <div data-id="element-1168">
                    <h4 className="text-2xl font-bold text-[#1a0647] mb-3" data-id="element-1169">
                      Ready to secure your family?
                    </h4>
                    <p className="text-gray-600 max-w-md" data-id="element-1170">
                      Join thousands of families who sleep better knowing their
                      digital lives are protected by Caveo.
                    </p>
                  </div>
                  {/* Blue primary CTA inside a purple-tinted zone */}
                  <button className="bg-[#214ae9] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#1a3bb8] transition-all shadow-sm flex items-center gap-2 whitespace-nowrap" data-id="element-1171">
                    View pricing plans <ChevronRightIcon size={18} data-id="element-1172" />
                  </button>
                </div>
              </div>

              {/* 5. Usage Legend */}
              <div data-id="element-1173">
                <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4" data-id="element-1174">
                  5. Role of Each Color
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1175">
                  {/* Blue = primary */}
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1176">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1177">
                      <div className="w-4 h-4 rounded-full bg-[#214ae9]" data-id="element-1178"></div>
                      Blue — Primary
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1179">
                      <li className="flex items-start gap-2" data-id="element-1180">
                        <div className="w-4 h-4 rounded-full bg-[#214ae9] shrink-0 mt-0.5" data-id="element-1181"></div>
                        <span data-id="element-1182">
                          <strong data-id="element-1183">Primary Actions:</strong> Main CTAs and key
                          buttons stay blue
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1184">
                        <div className="w-4 h-4 rounded-full bg-[#214ae9] bg-opacity-[0.08] border border-[#214ae9] shrink-0 mt-0.5" data-id="element-1185"></div>
                        <span data-id="element-1186">
                          <strong data-id="element-1187">Trust Signals:</strong> Security icons and
                          headline emphasis
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* Purple = accent */}
                  <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-1188">
                    <h4 className="font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1189">
                      <div className="w-4 h-4 rounded-full bg-[#631bb7]" data-id="element-1190"></div>
                      Purple — Accent
                    </h4>
                    <ul className="space-y-3 text-sm text-gray-600" data-id="element-1191">
                      <li className="flex items-start gap-2" data-id="element-1192">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-[0.08] border border-[#631bb7] shrink-0 mt-0.5" data-id="element-1193"></div>
                        <span data-id="element-1194">
                          <strong data-id="element-1195">Badges & Pills:</strong> Feature flags and
                          tertiary emphasis
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1196">
                        <div className="w-4 h-4 rounded-full bg-[#631bb7] bg-opacity-10 shrink-0 mt-0.5" data-id="element-1197"></div>
                        <span data-id="element-1198">
                          <strong data-id="element-1199">Soft Fills & Hovers:</strong> Section tints,
                          secondary card accents
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-1200">
                        <div className="w-4 h-4 rounded-full border-2 border-[#631bb7] shrink-0 mt-0.5" data-id="element-1201"></div>
                        <span data-id="element-1202">
                          <strong data-id="element-1203">Secondary Buttons:</strong> Outline / ghost
                          styles, not main actions
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-4" data-id="element-1204">
                  Cyan is fully retired in this direction — purple covers every
                  accent role.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}